<template>
  <gw-entity-filter-item :display-text="displayText" :property-name="propertyName"
    representation-field="caminho" :search="finder" :minimum-pattern-length="1"
      :find-values="findValues"
      :selection-support="listing"
      :defaultFilterParams="{ folha, tipo: [tipo] }">
    <template slot="item" slot-scope="{ entity }">
      <div>
        <strong>{{$t('ClassificacaoIndicador.ui.chooser.tipo')}} </strong>
        <span>{{$t(`ClassificacaoIndicador.tipo.${entity.tipo}`)}}</span>
      </div>
      <div>
        <strong>{{$t('ClassificacaoIndicador.ui.chooser.caminho')}} </strong>
        <span>{{entity.caminho}}</span>
      </div>
    </template>
  </gw-entity-filter-item>
</template>

<script>
import { GwEntityFilterItem, GwCustomFilterItemMixin } from 'guaxinim-web'
import ClassificacaoIndicadorRestResource from './ClassificacaoIndicadorRestResource'
import A7ClassificacaoIndicadorListing from './A7ClassificacaoIndicadorListing'

export default {
  name: 'a7-classificacao-indicador-filter-item',
  mixins: [GwCustomFilterItemMixin],
  components: {
    GwEntityFilterItem
  },
  props: {
    tipo: {
      type: String,
      default: null
    },
    folha: {
      type: Boolean,
      default: null
    }
  },
  data() {
    return {
      listing: A7ClassificacaoIndicadorListing
    }
  },
  methods: {
    finder(pattern) {
      if (!pattern) return null
      return ClassificacaoIndicadorRestResource.
        findClassificacaoIndicadorFinderDTO(pattern, this.tipo, this.folha, 10);
    },
    findValues(ids) {
      return ClassificacaoIndicadorRestResource.findEntities(ids)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
